/* eslint-disable max-len */
import { PhExceptionErrorType } from '@core/enums/ph-exception-error-type.enum';

export const OrderSubmissionErrorMessages = {
  [PhExceptionErrorType.OrderSubmitTransactionFailedException]: $localize`Please check your credit card details and resubmit your order`,
  [PhExceptionErrorType.OrderSubmitCvvDoesNotMatchException]: $localize`Please check your credit card details and resubmit your order`,
  [PhExceptionErrorType.OrderSubmitZipDoesNotMatchException]: $localize`Please check your credit card details and resubmit your order`,
  [PhExceptionErrorType.PipelineException]: $localize`Sorry but an error happened during the order placement. Please try again later or contact Princess House customer service!`,
};
